import { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { ApiUrlInjectionToken } from '@mitsubishi/shared/data-access';

@Injectable({
  providedIn: 'root',
})
export class AlternativeExtraService {
  private readonly baseUrl: string;

  constructor(
    private http: HttpClient,
    @Inject(ApiUrlInjectionToken) apiServerUrl: string
  ) {
    this.baseUrl = apiServerUrl + '/project';
  }

  createAlternativeExtra(projectId: string, selectionId: string, alternativeId: string): Observable<{ uuid: string }> {
    return this.http.post<{ uuid: string }>(
      `${this.baseUrl}/${projectId}/selection/${selectionId}/alternative/${alternativeId}/alternativeExtra`,
      {}
    );
  }

  deleteAlternativeExtra(projectId: string, selectionId: string, alternativeExtraId: string): Observable<null> {
    return this.http.delete<null>(
      `${this.baseUrl}/${projectId}/selection/${selectionId}/alternative/alternativeExtra/${alternativeExtraId}`
    );
  }

  updatePrice(projectId: string, selectionId: string, alternativeExtraId: string, price: number): Observable<null> {
    return this.http.put<null>(
      `${this.baseUrl}/${projectId}/selection/${selectionId}/alternative/alternativeExtra/${alternativeExtraId}/price`,
      { price }
    );
  }

  updateCustomerPrice(
    projectId: string,
    selectionId: string,
    alternativeExtraId: string,
    customer: number
  ): Observable<null> {
    return this.http.put<null>(
      `${this.baseUrl}/${projectId}/selection/${selectionId}/alternative/alternativeExtra/${alternativeExtraId}/customer`,
      { customer }
    );
  }

  updateName(projectId: string, selectionId: string, alternativeExtraId: string, name: string): Observable<null> {
    return this.http.put<null>(
      `${this.baseUrl}/${projectId}/selection/${selectionId}/alternative/alternativeExtra/${alternativeExtraId}/updateName`,
      { name }
    );
  }
}
